export default "__VITE_ASSET__DNScCaVN__"